import React from 'react'
import AnalyticsPdfTooltip from './AnalyticsPdfTooltip'
import styles from './AnalyticsPdfPageDetails.module.css'

const AnalyticsPdfQuestionIcon = ({ tooltip }) => (
  <AnalyticsPdfTooltip text={tooltip}>
    <span className={styles.questionIcon}>
      <img src="/assets/icons/help.svg" alt="Help" width="14" height="14" />
    </span>
  </AnalyticsPdfTooltip>
)

export default AnalyticsPdfQuestionIcon
